/* @flow */

import Immutable from 'immutable';
import { LoadingConstants } from '../constants/loading_constants';
import { SharedConstants } from '../constants/shared_constants';

const loadingInitialState = Immutable.Map()
  .set('sidebar', Immutable.Set())
  .set('blocking', Immutable.Set())
  .set('full', Immutable.Set());

function loadingReducer(state: Immutable.Map = loadingInitialState, action: Object): Immutable.Map {
  switch (action.type) {
    case SharedConstants.SHARED_PURGE:
      return loadingInitialState;
    case LoadingConstants.LOADING_START:
      if (action.id && (action.loadingType !== 'silent')) {
        if (action.loadingType === 'blocking') {
          return state.update('blocking', blocking => blocking.add(action.id));
        } else if (action.loadingType === 'full') {
          return state.update('full', full => full.add(action.id));
        } else {
          return state.update('sidebar', sidebar => sidebar.add(action.id));
        }
      }
      break;
    case LoadingConstants.LOADING_STOP:
      if (action.id) {
        return state
          .update('sidebar', sidebar => sidebar.remove(action.id))
          .update('blocking', blocking => blocking.remove(action.id))
          .update('full', full => full.remove(action.id));
      }
      break;
  }
  return state;
}

export {
  loadingInitialState,
  loadingReducer
};
